import { FormlyFieldConfig } from '@ngx-formly/core';

import { SearchCriteria, ColumnInformation, PaginationSpecification } from './framework/searchObjects';

export interface IPagedResult
                {
                    PaginationInfo: PaginationSpecification;
                    TotalCount: Number;
                    Data: any[];
                }
	export class AddressDto {
		Id: number;
		Address1: string;
		Address2: string;
		Address3: string;
		City: string;
		StateId: number;
		StatesList: ValueTextDto[] = [];
		CountryId: number;
		CountriesList: CountryValueTextDto[] = [];
		Zip: string;
		IsInternational: boolean;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAddress1() : FormlyFieldConfig {
			return {
			  "key": "Address1",
			  "name": "Address1",
			  "templateOptions": {
			    "label": "Address1"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAddress2() : FormlyFieldConfig {
			return {
			  "key": "Address2",
			  "name": "Address2",
			  "templateOptions": {
			    "label": "Address2"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAddress3() : FormlyFieldConfig {
			return {
			  "key": "Address3",
			  "name": "Address3",
			  "templateOptions": {
			    "label": "Address3"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCity() : FormlyFieldConfig {
			return {
			  "key": "City",
			  "name": "City",
			  "templateOptions": {
			    "label": "City"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStateId() : FormlyFieldConfig {
			return {
			  "key": "StateId",
			  "name": "StateId",
			  "templateOptions": {
			    "type": "number",
			    "label": "StateId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStatesList() : FormlyFieldConfig {
			return {
			  "key": "StatesList",
			  "name": "StatesList",
			  "templateOptions": {
			    "label": "StatesList",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigCountryId() : FormlyFieldConfig {
			return {
			  "key": "CountryId",
			  "name": "CountryId",
			  "templateOptions": {
			    "type": "number",
			    "label": "CountryId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCountriesList() : FormlyFieldConfig {
			return {
			  "key": "CountriesList",
			  "name": "CountriesList",
			  "templateOptions": {
			    "label": "CountriesList",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigZip() : FormlyFieldConfig {
			return {
			  "key": "Zip",
			  "name": "Zip",
			  "templateOptions": {
			    "label": "Zip"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsInternational() : FormlyFieldConfig {
			return {
			  "key": "IsInternational",
			  "name": "IsInternational",
			  "templateOptions": {
			    "label": "IsInternational"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				AddressDto.FormlyConfigId,
				AddressDto.FormlyConfigAddress1,
				AddressDto.FormlyConfigAddress2,
				AddressDto.FormlyConfigAddress3,
				AddressDto.FormlyConfigCity,
				AddressDto.FormlyConfigStateId,
				AddressDto.FormlyConfigStatesList,
				AddressDto.FormlyConfigCountryId,
				AddressDto.FormlyConfigCountriesList,
				AddressDto.FormlyConfigZip,
				AddressDto.FormlyConfigIsInternational
			];
		};
	}

	export class ApplicationSettingSearchRow {
		Id: number;
		Name: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ApplicationSettingSearchRow.FormlyConfigId,
				ApplicationSettingSearchRow.FormlyConfigName
			];
		};
	}

	export class AssetDto {
		AssetId: number;
		Client: ClientDto = new ClientDto();
		Name: string;
		Description: string;
		Active: boolean;

		static get FormlyConfigAssetId() : FormlyFieldConfig {
			return {
			  "key": "AssetId",
			  "name": "AssetId",
			  "templateOptions": {
			    "type": "number",
			    "label": "AssetId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigClient() : FormlyFieldConfig {
			return {
			  "key": "Client",
			  "name": "Client",
			  "templateOptions": {
			    "type": "ClientDto = new ClientDto()",
			    "label": "Client"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				AssetDto.FormlyConfigAssetId,
				AssetDto.FormlyConfigClient,
				AssetDto.FormlyConfigName,
				AssetDto.FormlyConfigDescription,
				AssetDto.FormlyConfigActive
			];
		};
	}

	export class ClientDto {
		ClientId: number;
		Name: string;
		Description: string;
		Active: boolean;

		static get FormlyConfigClientId() : FormlyFieldConfig {
			return {
			  "key": "ClientId",
			  "name": "ClientId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ClientId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ClientDto.FormlyConfigClientId,
				ClientDto.FormlyConfigName,
				ClientDto.FormlyConfigDescription,
				ClientDto.FormlyConfigActive
			];
		};
	}

	export class CommandSecurityCheckpointDto {
		CommandName: string;
		HasAccess: boolean;

		static get FormlyConfigCommandName() : FormlyFieldConfig {
			return {
			  "key": "CommandName",
			  "name": "CommandName",
			  "templateOptions": {
			    "label": "CommandName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigHasAccess() : FormlyFieldConfig {
			return {
			  "key": "HasAccess",
			  "name": "HasAccess",
			  "templateOptions": {
			    "label": "HasAccess"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CommandSecurityCheckpointDto.FormlyConfigCommandName,
				CommandSecurityCheckpointDto.FormlyConfigHasAccess
			];
		};
	}

	export class CommandSecurityRoleSearchRow {
		Id: number;
		SecurityCheckpointId: number;
		CommandName: string;
		Description: string;
		RoleId: number;
		Role: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSecurityCheckpointId() : FormlyFieldConfig {
			return {
			  "key": "SecurityCheckpointId",
			  "name": "SecurityCheckpointId",
			  "templateOptions": {
			    "type": "number",
			    "label": "SecurityCheckpointId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCommandName() : FormlyFieldConfig {
			return {
			  "key": "CommandName",
			  "name": "CommandName",
			  "templateOptions": {
			    "label": "CommandName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRoleId() : FormlyFieldConfig {
			return {
			  "key": "RoleId",
			  "name": "RoleId",
			  "templateOptions": {
			    "type": "number",
			    "label": "RoleId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRole() : FormlyFieldConfig {
			return {
			  "key": "Role",
			  "name": "Role",
			  "templateOptions": {
			    "label": "Role"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CommandSecurityRoleSearchRow.FormlyConfigId,
				CommandSecurityRoleSearchRow.FormlyConfigSecurityCheckpointId,
				CommandSecurityRoleSearchRow.FormlyConfigCommandName,
				CommandSecurityRoleSearchRow.FormlyConfigDescription,
				CommandSecurityRoleSearchRow.FormlyConfigRoleId,
				CommandSecurityRoleSearchRow.FormlyConfigRole
			];
		};
	}

	export class CompanyDto {
		CompanyId: number;
		Name: string;

		static get FormlyConfigCompanyId() : FormlyFieldConfig {
			return {
			  "key": "CompanyId",
			  "name": "CompanyId",
			  "templateOptions": {
			    "type": "number",
			    "label": "CompanyId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CompanyDto.FormlyConfigCompanyId,
				CompanyDto.FormlyConfigName
			];
		};
	}

	export class CountryDto {
		Id: number;
		Name: string;
		IsInternational: boolean;
		IsActive: boolean = true;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsInternational() : FormlyFieldConfig {
			return {
			  "key": "IsInternational",
			  "name": "IsInternational",
			  "templateOptions": {
			    "label": "IsInternational"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CountryDto.FormlyConfigId,
				CountryDto.FormlyConfigName,
				CountryDto.FormlyConfigIsInternational,
				CountryDto.FormlyConfigIsActive
			];
		};
	}

	export class CountrySearchRow {
		Id: number;
		Name: string;
		IsActive: boolean = true;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CountrySearchRow.FormlyConfigId,
				CountrySearchRow.FormlyConfigName,
				CountrySearchRow.FormlyConfigIsActive
			];
		};
	}

	export class CountryValueTextDto {
		Value: number;
		IsInternational: boolean;
		Text: string;

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsInternational() : FormlyFieldConfig {
			return {
			  "key": "IsInternational",
			  "name": "IsInternational",
			  "templateOptions": {
			    "label": "IsInternational"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigText() : FormlyFieldConfig {
			return {
			  "key": "Text",
			  "name": "Text",
			  "templateOptions": {
			    "label": "Text"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CountryValueTextDto.FormlyConfigValue,
				CountryValueTextDto.FormlyConfigIsInternational,
				CountryValueTextDto.FormlyConfigText
			];
		};
	}

	export class CountWidgetDto {
		ReferenceName: string;
		DisplayName: string;
		ViewName: string;
		Link: string;
		Count: number;
		Id: number;
		Order: number;
		WidgetType: WidgetType;
		Selected: boolean;

		static get FormlyConfigReferenceName() : FormlyFieldConfig {
			return {
			  "key": "ReferenceName",
			  "name": "ReferenceName",
			  "templateOptions": {
			    "label": "ReferenceName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDisplayName() : FormlyFieldConfig {
			return {
			  "key": "DisplayName",
			  "name": "DisplayName",
			  "templateOptions": {
			    "label": "DisplayName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigViewName() : FormlyFieldConfig {
			return {
			  "key": "ViewName",
			  "name": "ViewName",
			  "templateOptions": {
			    "label": "ViewName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLink() : FormlyFieldConfig {
			return {
			  "key": "Link",
			  "name": "Link",
			  "templateOptions": {
			    "label": "Link"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCount() : FormlyFieldConfig {
			return {
			  "key": "Count",
			  "name": "Count",
			  "templateOptions": {
			    "type": "number",
			    "label": "Count"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWidgetType() : FormlyFieldConfig {
			return {
			  "key": "WidgetType",
			  "name": "WidgetType",
			  "templateOptions": {
			    "type": "WidgetType = new WidgetType()",
			    "label": "WidgetType",
			    "options": [
			      {
			        "label": "Count",
			        "value": "0"
			      }
			    ]
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSelected() : FormlyFieldConfig {
			return {
			  "key": "Selected",
			  "name": "Selected",
			  "templateOptions": {
			    "label": "Selected"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CountWidgetDto.FormlyConfigReferenceName,
				CountWidgetDto.FormlyConfigDisplayName,
				CountWidgetDto.FormlyConfigViewName,
				CountWidgetDto.FormlyConfigLink,
				CountWidgetDto.FormlyConfigCount,
				CountWidgetDto.FormlyConfigId,
				CountWidgetDto.FormlyConfigOrder,
				CountWidgetDto.FormlyConfigWidgetType,
				CountWidgetDto.FormlyConfigSelected
			];
		};
	}

	export class DashboardDto {
		Widgets: WidgetDto[] = [];

		static get FormlyConfigWidgets() : FormlyFieldConfig {
			return {
			  "key": "Widgets",
			  "name": "Widgets",
			  "templateOptions": {
			    "label": "Widgets",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DashboardDto.FormlyConfigWidgets
			];
		};
	}

	export class DateDto {
		Day: number;
		Month: number;
		Year: number;

		static get FormlyConfigDay() : FormlyFieldConfig {
			return {
			  "key": "Day",
			  "name": "Day",
			  "templateOptions": {
			    "type": "number",
			    "label": "Day"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMonth() : FormlyFieldConfig {
			return {
			  "key": "Month",
			  "name": "Month",
			  "templateOptions": {
			    "type": "number",
			    "label": "Month"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigYear() : FormlyFieldConfig {
			return {
			  "key": "Year",
			  "name": "Year",
			  "templateOptions": {
			    "type": "number",
			    "label": "Year"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DateDto.FormlyConfigDay,
				DateDto.FormlyConfigMonth,
				DateDto.FormlyConfigYear
			];
		};
	}

	export class ErrorLogSearchRow {
		Id: number;
		CreationDate: Date;
		ApplicationName: string;
		URL: string;
		User: string;
		EnvironmentInfo: string;
		Message: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreationDate() : FormlyFieldConfig {
			return {
			  "key": "CreationDate",
			  "name": "CreationDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "CreationDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigApplicationName() : FormlyFieldConfig {
			return {
			  "key": "ApplicationName",
			  "name": "ApplicationName",
			  "templateOptions": {
			    "label": "ApplicationName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigURL() : FormlyFieldConfig {
			return {
			  "key": "URL",
			  "name": "URL",
			  "templateOptions": {
			    "label": "URL"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUser() : FormlyFieldConfig {
			return {
			  "key": "User",
			  "name": "User",
			  "templateOptions": {
			    "label": "User"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigEnvironmentInfo() : FormlyFieldConfig {
			return {
			  "key": "EnvironmentInfo",
			  "name": "EnvironmentInfo",
			  "templateOptions": {
			    "label": "EnvironmentInfo"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMessage() : FormlyFieldConfig {
			return {
			  "key": "Message",
			  "name": "Message",
			  "templateOptions": {
			    "label": "Message"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ErrorLogSearchRow.FormlyConfigId,
				ErrorLogSearchRow.FormlyConfigCreationDate,
				ErrorLogSearchRow.FormlyConfigApplicationName,
				ErrorLogSearchRow.FormlyConfigURL,
				ErrorLogSearchRow.FormlyConfigUser,
				ErrorLogSearchRow.FormlyConfigEnvironmentInfo,
				ErrorLogSearchRow.FormlyConfigMessage
			];
		};
	}

	export class ExampleSearchRow {
		Id: number;
		CreateDate: Date;
		Key: string;
		DisplayText: string;
		Value: string;
		ExampleLookupDisplayText: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreateDate() : FormlyFieldConfig {
			return {
			  "key": "CreateDate",
			  "name": "CreateDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "CreateDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigKey() : FormlyFieldConfig {
			return {
			  "key": "Key",
			  "name": "Key",
			  "templateOptions": {
			    "label": "Key"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDisplayText() : FormlyFieldConfig {
			return {
			  "key": "DisplayText",
			  "name": "DisplayText",
			  "templateOptions": {
			    "label": "DisplayText"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigExampleLookupDisplayText() : FormlyFieldConfig {
			return {
			  "key": "ExampleLookupDisplayText",
			  "name": "ExampleLookupDisplayText",
			  "templateOptions": {
			    "label": "ExampleLookupDisplayText"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExampleSearchRow.FormlyConfigId,
				ExampleSearchRow.FormlyConfigCreateDate,
				ExampleSearchRow.FormlyConfigKey,
				ExampleSearchRow.FormlyConfigDisplayText,
				ExampleSearchRow.FormlyConfigValue,
				ExampleSearchRow.FormlyConfigExampleLookupDisplayText
			];
		};
	}

	export class ExecutionBarChartDto {
		LastActivityDate: Date;
		BaselineManHoursTotal: number;
		BaselineManHoursToDate: number;
		AtCompletionManHoursTotal: number;
		ActualManHoursTotal: number;
		ActualPercentComplete: number;
		BaselinePercentComplete: number;
		ProjectedPercentComplete: number;

		static get FormlyConfigLastActivityDate() : FormlyFieldConfig {
			return {
			  "key": "LastActivityDate",
			  "name": "LastActivityDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "LastActivityDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBaselineManHoursTotal() : FormlyFieldConfig {
			return {
			  "key": "BaselineManHoursTotal",
			  "name": "BaselineManHoursTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "BaselineManHoursTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBaselineManHoursToDate() : FormlyFieldConfig {
			return {
			  "key": "BaselineManHoursToDate",
			  "name": "BaselineManHoursToDate",
			  "templateOptions": {
			    "type": "number",
			    "label": "BaselineManHoursToDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAtCompletionManHoursTotal() : FormlyFieldConfig {
			return {
			  "key": "AtCompletionManHoursTotal",
			  "name": "AtCompletionManHoursTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "AtCompletionManHoursTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActualManHoursTotal() : FormlyFieldConfig {
			return {
			  "key": "ActualManHoursTotal",
			  "name": "ActualManHoursTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "ActualManHoursTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActualPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "ActualPercentComplete",
			  "name": "ActualPercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "ActualPercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBaselinePercentComplete() : FormlyFieldConfig {
			return {
			  "key": "BaselinePercentComplete",
			  "name": "BaselinePercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "BaselinePercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectedPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "ProjectedPercentComplete",
			  "name": "ProjectedPercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectedPercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecutionBarChartDto.FormlyConfigLastActivityDate,
				ExecutionBarChartDto.FormlyConfigBaselineManHoursTotal,
				ExecutionBarChartDto.FormlyConfigBaselineManHoursToDate,
				ExecutionBarChartDto.FormlyConfigAtCompletionManHoursTotal,
				ExecutionBarChartDto.FormlyConfigActualManHoursTotal,
				ExecutionBarChartDto.FormlyConfigActualPercentComplete,
				ExecutionBarChartDto.FormlyConfigBaselinePercentComplete,
				ExecutionBarChartDto.FormlyConfigProjectedPercentComplete
			];
		};
	}

	export class ExecutionChartDataDto {
		name: string;
		series: ExecutionChartDataSeriesDto[] = [];

		static get FormlyConfigname() : FormlyFieldConfig {
			return {
			  "key": "name",
			  "name": "name",
			  "templateOptions": {
			    "label": "name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigseries() : FormlyFieldConfig {
			return {
			  "key": "series",
			  "name": "series",
			  "templateOptions": {
			    "label": "series",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecutionChartDataDto.FormlyConfigname,
				ExecutionChartDataDto.FormlyConfigseries
			];
		};
	}

	export class ExecutionChartDataSeriesDto {
		name: string;
		value: number;

		static get FormlyConfigname() : FormlyFieldConfig {
			return {
			  "key": "name",
			  "name": "name",
			  "templateOptions": {
			    "label": "name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigvalue() : FormlyFieldConfig {
			return {
			  "key": "value",
			  "name": "value",
			  "templateOptions": {
			    "type": "number",
			    "label": "value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecutionChartDataSeriesDto.FormlyConfigname,
				ExecutionChartDataSeriesDto.FormlyConfigvalue
			];
		};
	}

	export class ExecutionScheduleDto {
		ChartData: ExecutionChartDataDto[] = [];

		static get FormlyConfigChartData() : FormlyFieldConfig {
			return {
			  "key": "ChartData",
			  "name": "ChartData",
			  "templateOptions": {
			    "label": "ChartData",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecutionScheduleDto.FormlyConfigChartData
			];
		};
	}

	export class ExecutionSummaryDto {
		TotalItems: number;
		PercentComplete: number;
		ExecutionAccessUrl: string;
		TimeEntryAccessUrl: string;
		ProjectStatusReportUrl: string;
		BaselineFinishDate: string;
		ProjectFinishDate: string;
		ProjectedStartDate: string;
		ProjectDataDate: string;
		ExecutionWbsLevels: SummaryStageDto[] = [];

		static get FormlyConfigTotalItems() : FormlyFieldConfig {
			return {
			  "key": "TotalItems",
			  "name": "TotalItems",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalItems"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigExecutionAccessUrl() : FormlyFieldConfig {
			return {
			  "key": "ExecutionAccessUrl",
			  "name": "ExecutionAccessUrl",
			  "templateOptions": {
			    "label": "ExecutionAccessUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTimeEntryAccessUrl() : FormlyFieldConfig {
			return {
			  "key": "TimeEntryAccessUrl",
			  "name": "TimeEntryAccessUrl",
			  "templateOptions": {
			    "label": "TimeEntryAccessUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectStatusReportUrl() : FormlyFieldConfig {
			return {
			  "key": "ProjectStatusReportUrl",
			  "name": "ProjectStatusReportUrl",
			  "templateOptions": {
			    "label": "ProjectStatusReportUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBaselineFinishDate() : FormlyFieldConfig {
			return {
			  "key": "BaselineFinishDate",
			  "name": "BaselineFinishDate",
			  "templateOptions": {
			    "label": "BaselineFinishDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectFinishDate() : FormlyFieldConfig {
			return {
			  "key": "ProjectFinishDate",
			  "name": "ProjectFinishDate",
			  "templateOptions": {
			    "label": "ProjectFinishDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectedStartDate() : FormlyFieldConfig {
			return {
			  "key": "ProjectedStartDate",
			  "name": "ProjectedStartDate",
			  "templateOptions": {
			    "label": "ProjectedStartDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectDataDate() : FormlyFieldConfig {
			return {
			  "key": "ProjectDataDate",
			  "name": "ProjectDataDate",
			  "templateOptions": {
			    "label": "ProjectDataDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigExecutionWbsLevels() : FormlyFieldConfig {
			return {
			  "key": "ExecutionWbsLevels",
			  "name": "ExecutionWbsLevels",
			  "templateOptions": {
			    "label": "ExecutionWbsLevels",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecutionSummaryDto.FormlyConfigTotalItems,
				ExecutionSummaryDto.FormlyConfigPercentComplete,
				ExecutionSummaryDto.FormlyConfigExecutionAccessUrl,
				ExecutionSummaryDto.FormlyConfigTimeEntryAccessUrl,
				ExecutionSummaryDto.FormlyConfigProjectStatusReportUrl,
				ExecutionSummaryDto.FormlyConfigBaselineFinishDate,
				ExecutionSummaryDto.FormlyConfigProjectFinishDate,
				ExecutionSummaryDto.FormlyConfigProjectedStartDate,
				ExecutionSummaryDto.FormlyConfigProjectDataDate,
				ExecutionSummaryDto.FormlyConfigExecutionWbsLevels
			];
		};
	}

	export class FileDto {
		Bytes: Blob;
		Base64String: string;
		Name: string;
		MimeType: string;

		static get FormlyConfigBytes() : FormlyFieldConfig {
			return {
			  "key": "Bytes",
			  "name": "Bytes",
			  "templateOptions": {
			    "label": "Bytes",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigBase64String() : FormlyFieldConfig {
			return {
			  "key": "Base64String",
			  "name": "Base64String",
			  "templateOptions": {
			    "label": "Base64String"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMimeType() : FormlyFieldConfig {
			return {
			  "key": "MimeType",
			  "name": "MimeType",
			  "templateOptions": {
			    "label": "MimeType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				FileDto.FormlyConfigBytes,
				FileDto.FormlyConfigBase64String,
				FileDto.FormlyConfigName,
				FileDto.FormlyConfigMimeType
			];
		};
	}

	export class IntegrationSettingValue {
		IntegrationName: string;
		SettingValue: string;

		static get FormlyConfigIntegrationName() : FormlyFieldConfig {
			return {
			  "key": "IntegrationName",
			  "name": "IntegrationName",
			  "templateOptions": {
			    "label": "IntegrationName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSettingValue() : FormlyFieldConfig {
			return {
			  "key": "SettingValue",
			  "name": "SettingValue",
			  "templateOptions": {
			    "label": "SettingValue"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				IntegrationSettingValue.FormlyConfigIntegrationName,
				IntegrationSettingValue.FormlyConfigSettingValue
			];
		};
	}

	export class LinkDto {
		id: number;
		type: string;
		source: number;
		target: number;

		static get FormlyConfigid() : FormlyFieldConfig {
			return {
			  "key": "id",
			  "name": "id",
			  "templateOptions": {
			    "type": "number",
			    "label": "id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigtype() : FormlyFieldConfig {
			return {
			  "key": "type",
			  "name": "type",
			  "templateOptions": {
			    "label": "type"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigsource() : FormlyFieldConfig {
			return {
			  "key": "source",
			  "name": "source",
			  "templateOptions": {
			    "type": "number",
			    "label": "source"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigtarget() : FormlyFieldConfig {
			return {
			  "key": "target",
			  "name": "target",
			  "templateOptions": {
			    "type": "number",
			    "label": "target"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				LinkDto.FormlyConfigid,
				LinkDto.FormlyConfigtype,
				LinkDto.FormlyConfigsource,
				LinkDto.FormlyConfigtarget
			];
		};
	}

	export class MaterialsPhaseDto {
		PhaseId: number;
		PhaseName: string;
		TotalItems: number;
		PercentComplete: number;

		static get FormlyConfigPhaseId() : FormlyFieldConfig {
			return {
			  "key": "PhaseId",
			  "name": "PhaseId",
			  "templateOptions": {
			    "type": "number",
			    "label": "PhaseId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPhaseName() : FormlyFieldConfig {
			return {
			  "key": "PhaseName",
			  "name": "PhaseName",
			  "templateOptions": {
			    "label": "PhaseName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalItems() : FormlyFieldConfig {
			return {
			  "key": "TotalItems",
			  "name": "TotalItems",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalItems"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				MaterialsPhaseDto.FormlyConfigPhaseId,
				MaterialsPhaseDto.FormlyConfigPhaseName,
				MaterialsPhaseDto.FormlyConfigTotalItems,
				MaterialsPhaseDto.FormlyConfigPercentComplete
			];
		};
	}

	export class MaterialsSchemaDto {
		SchemaId: number;
		SchemaName: string;
		TotalItems: number;
		PercentComplete: number;
		MaterialsPhases: MaterialsPhaseDto[] = [];

		static get FormlyConfigSchemaId() : FormlyFieldConfig {
			return {
			  "key": "SchemaId",
			  "name": "SchemaId",
			  "templateOptions": {
			    "type": "number",
			    "label": "SchemaId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSchemaName() : FormlyFieldConfig {
			return {
			  "key": "SchemaName",
			  "name": "SchemaName",
			  "templateOptions": {
			    "label": "SchemaName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalItems() : FormlyFieldConfig {
			return {
			  "key": "TotalItems",
			  "name": "TotalItems",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalItems"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterialsPhases() : FormlyFieldConfig {
			return {
			  "key": "MaterialsPhases",
			  "name": "MaterialsPhases",
			  "templateOptions": {
			    "label": "MaterialsPhases",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				MaterialsSchemaDto.FormlyConfigSchemaId,
				MaterialsSchemaDto.FormlyConfigSchemaName,
				MaterialsSchemaDto.FormlyConfigTotalItems,
				MaterialsSchemaDto.FormlyConfigPercentComplete,
				MaterialsSchemaDto.FormlyConfigMaterialsPhases
			];
		};
	}

	export class MaterialsStageStatusDto {
		TotalItems: number;
		PercentComplete: number;
		MaterialsAccessUrl: string;
		MaterialsSchemas: MaterialsSchemaDto[] = [];

		static get FormlyConfigTotalItems() : FormlyFieldConfig {
			return {
			  "key": "TotalItems",
			  "name": "TotalItems",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalItems"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterialsAccessUrl() : FormlyFieldConfig {
			return {
			  "key": "MaterialsAccessUrl",
			  "name": "MaterialsAccessUrl",
			  "templateOptions": {
			    "label": "MaterialsAccessUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterialsSchemas() : FormlyFieldConfig {
			return {
			  "key": "MaterialsSchemas",
			  "name": "MaterialsSchemas",
			  "templateOptions": {
			    "label": "MaterialsSchemas",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				MaterialsStageStatusDto.FormlyConfigTotalItems,
				MaterialsStageStatusDto.FormlyConfigPercentComplete,
				MaterialsStageStatusDto.FormlyConfigMaterialsAccessUrl,
				MaterialsStageStatusDto.FormlyConfigMaterialsSchemas
			];
		};
	}

	export class ModuleDisplaySettingDto {
		DisplayReadiness: boolean;
		DisplayMaterials: boolean;
		DisplayExecution: boolean;

		static get FormlyConfigDisplayReadiness() : FormlyFieldConfig {
			return {
			  "key": "DisplayReadiness",
			  "name": "DisplayReadiness",
			  "templateOptions": {
			    "label": "DisplayReadiness"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigDisplayMaterials() : FormlyFieldConfig {
			return {
			  "key": "DisplayMaterials",
			  "name": "DisplayMaterials",
			  "templateOptions": {
			    "label": "DisplayMaterials"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigDisplayExecution() : FormlyFieldConfig {
			return {
			  "key": "DisplayExecution",
			  "name": "DisplayExecution",
			  "templateOptions": {
			    "label": "DisplayExecution"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ModuleDisplaySettingDto.FormlyConfigDisplayReadiness,
				ModuleDisplaySettingDto.FormlyConfigDisplayMaterials,
				ModuleDisplaySettingDto.FormlyConfigDisplayExecution
			];
		};
	}

	export class ProjectDto {
		ProjectId: number;
		Asset: AssetDto = new AssetDto();
		Client: ClientDto = new ClientDto();
		Name: string;
		Description: string;
		Active: boolean;
		PrimaveraIdentifiers: string[] = [];
		SiteSenseIdentifiers: string[] = [];
		ClientIdentifiers: string[] = [];
		CXPlannerIdentifiers: string[] = [];
		ReadinessAssessmentPath: string;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAsset() : FormlyFieldConfig {
			return {
			  "key": "Asset",
			  "name": "Asset",
			  "templateOptions": {
			    "type": "AssetDto = new AssetDto()",
			    "label": "Asset"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigClient() : FormlyFieldConfig {
			return {
			  "key": "Client",
			  "name": "Client",
			  "templateOptions": {
			    "type": "ClientDto = new ClientDto()",
			    "label": "Client"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigPrimaveraIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "PrimaveraIdentifiers",
			  "name": "PrimaveraIdentifiers",
			  "templateOptions": {
			    "label": "PrimaveraIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigSiteSenseIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "SiteSenseIdentifiers",
			  "name": "SiteSenseIdentifiers",
			  "templateOptions": {
			    "label": "SiteSenseIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigClientIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "ClientIdentifiers",
			  "name": "ClientIdentifiers",
			  "templateOptions": {
			    "label": "ClientIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigCXPlannerIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "CXPlannerIdentifiers",
			  "name": "CXPlannerIdentifiers",
			  "templateOptions": {
			    "label": "CXPlannerIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigReadinessAssessmentPath() : FormlyFieldConfig {
			return {
			  "key": "ReadinessAssessmentPath",
			  "name": "ReadinessAssessmentPath",
			  "templateOptions": {
			    "label": "ReadinessAssessmentPath"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectDto.FormlyConfigProjectId,
				ProjectDto.FormlyConfigAsset,
				ProjectDto.FormlyConfigClient,
				ProjectDto.FormlyConfigName,
				ProjectDto.FormlyConfigDescription,
				ProjectDto.FormlyConfigActive,
				ProjectDto.FormlyConfigPrimaveraIdentifiers,
				ProjectDto.FormlyConfigSiteSenseIdentifiers,
				ProjectDto.FormlyConfigClientIdentifiers,
				ProjectDto.FormlyConfigCXPlannerIdentifiers,
				ProjectDto.FormlyConfigReadinessAssessmentPath
			];
		};
	}

	export class ProjectPrioritySummaryDto {
		Project: ProjectDto = new ProjectDto();
		SummaryPriorities: SummaryPriorityDto[] = [];

		static get FormlyConfigProject() : FormlyFieldConfig {
			return {
			  "key": "Project",
			  "name": "Project",
			  "templateOptions": {
			    "type": "ProjectDto = new ProjectDto()",
			    "label": "Project"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSummaryPriorities() : FormlyFieldConfig {
			return {
			  "key": "SummaryPriorities",
			  "name": "SummaryPriorities",
			  "templateOptions": {
			    "label": "SummaryPriorities",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectPrioritySummaryDto.FormlyConfigProject,
				ProjectPrioritySummaryDto.FormlyConfigSummaryPriorities
			];
		};
	}

	export class ProjectSetupDto {
		Id: number;
		ProPakProject: ProjectDto = new ProjectDto();
		ReadinessAssessmentPath: string;
		PrimaveraIdentifiers: string[] = [];
		SiteSenseIdentifiers: string[] = [];
		ClientIdentifiers: string[] = [];
		CXPlannerIdentifiers: string[] = [];
		UserRoles: UserRoleDto[] = [];
		PowerBiReportPath: string;
		ProjectDisplayType: string;
		ShowProjected: boolean;
		MasterReport: string;
		ActivitiesDisplayType: string;
		ShowFullSchedule: boolean;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProPakProject() : FormlyFieldConfig {
			return {
			  "key": "ProPakProject",
			  "name": "ProPakProject",
			  "templateOptions": {
			    "type": "ProjectDto = new ProjectDto()",
			    "label": "ProPakProject"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigReadinessAssessmentPath() : FormlyFieldConfig {
			return {
			  "key": "ReadinessAssessmentPath",
			  "name": "ReadinessAssessmentPath",
			  "templateOptions": {
			    "label": "ReadinessAssessmentPath"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPrimaveraIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "PrimaveraIdentifiers",
			  "name": "PrimaveraIdentifiers",
			  "templateOptions": {
			    "label": "PrimaveraIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigSiteSenseIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "SiteSenseIdentifiers",
			  "name": "SiteSenseIdentifiers",
			  "templateOptions": {
			    "label": "SiteSenseIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigClientIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "ClientIdentifiers",
			  "name": "ClientIdentifiers",
			  "templateOptions": {
			    "label": "ClientIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigCXPlannerIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "CXPlannerIdentifiers",
			  "name": "CXPlannerIdentifiers",
			  "templateOptions": {
			    "label": "CXPlannerIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigUserRoles() : FormlyFieldConfig {
			return {
			  "key": "UserRoles",
			  "name": "UserRoles",
			  "templateOptions": {
			    "label": "UserRoles",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigPowerBiReportPath() : FormlyFieldConfig {
			return {
			  "key": "PowerBiReportPath",
			  "name": "PowerBiReportPath",
			  "templateOptions": {
			    "label": "PowerBiReportPath"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectDisplayType() : FormlyFieldConfig {
			return {
			  "key": "ProjectDisplayType",
			  "name": "ProjectDisplayType",
			  "templateOptions": {
			    "label": "ProjectDisplayType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigShowProjected() : FormlyFieldConfig {
			return {
			  "key": "ShowProjected",
			  "name": "ShowProjected",
			  "templateOptions": {
			    "label": "ShowProjected"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigMasterReport() : FormlyFieldConfig {
			return {
			  "key": "MasterReport",
			  "name": "MasterReport",
			  "templateOptions": {
			    "label": "MasterReport"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActivitiesDisplayType() : FormlyFieldConfig {
			return {
			  "key": "ActivitiesDisplayType",
			  "name": "ActivitiesDisplayType",
			  "templateOptions": {
			    "label": "ActivitiesDisplayType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigShowFullSchedule() : FormlyFieldConfig {
			return {
			  "key": "ShowFullSchedule",
			  "name": "ShowFullSchedule",
			  "templateOptions": {
			    "label": "ShowFullSchedule"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectSetupDto.FormlyConfigId,
				ProjectSetupDto.FormlyConfigProPakProject,
				ProjectSetupDto.FormlyConfigReadinessAssessmentPath,
				ProjectSetupDto.FormlyConfigPrimaveraIdentifiers,
				ProjectSetupDto.FormlyConfigSiteSenseIdentifiers,
				ProjectSetupDto.FormlyConfigClientIdentifiers,
				ProjectSetupDto.FormlyConfigCXPlannerIdentifiers,
				ProjectSetupDto.FormlyConfigUserRoles,
				ProjectSetupDto.FormlyConfigPowerBiReportPath,
				ProjectSetupDto.FormlyConfigProjectDisplayType,
				ProjectSetupDto.FormlyConfigShowProjected,
				ProjectSetupDto.FormlyConfigMasterReport,
				ProjectSetupDto.FormlyConfigActivitiesDisplayType,
				ProjectSetupDto.FormlyConfigShowFullSchedule
			];
		};
	}

	export class ReadinessCategoryStatusDto {
		CategoryId: number;
		CategoryName: string;
		TaskCountSatisfied: number;
		TaskCountInProgress: number;
		TaskCountInComplete: number;
		TaskCountTotal: number;
		StatusPercentage: number;
		PercentComplete: number;
		PercentInProgress: number;
		PercentIncomplete: number;

		static get FormlyConfigCategoryId() : FormlyFieldConfig {
			return {
			  "key": "CategoryId",
			  "name": "CategoryId",
			  "templateOptions": {
			    "type": "number",
			    "label": "CategoryId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCategoryName() : FormlyFieldConfig {
			return {
			  "key": "CategoryName",
			  "name": "CategoryName",
			  "templateOptions": {
			    "label": "CategoryName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountSatisfied() : FormlyFieldConfig {
			return {
			  "key": "TaskCountSatisfied",
			  "name": "TaskCountSatisfied",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountSatisfied"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountInProgress() : FormlyFieldConfig {
			return {
			  "key": "TaskCountInProgress",
			  "name": "TaskCountInProgress",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountInProgress"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountInComplete() : FormlyFieldConfig {
			return {
			  "key": "TaskCountInComplete",
			  "name": "TaskCountInComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountInComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountTotal() : FormlyFieldConfig {
			return {
			  "key": "TaskCountTotal",
			  "name": "TaskCountTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStatusPercentage() : FormlyFieldConfig {
			return {
			  "key": "StatusPercentage",
			  "name": "StatusPercentage",
			  "templateOptions": {
			    "type": "number",
			    "label": "StatusPercentage"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentInProgress() : FormlyFieldConfig {
			return {
			  "key": "PercentInProgress",
			  "name": "PercentInProgress",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentInProgress"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentIncomplete() : FormlyFieldConfig {
			return {
			  "key": "PercentIncomplete",
			  "name": "PercentIncomplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentIncomplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessCategoryStatusDto.FormlyConfigCategoryId,
				ReadinessCategoryStatusDto.FormlyConfigCategoryName,
				ReadinessCategoryStatusDto.FormlyConfigTaskCountSatisfied,
				ReadinessCategoryStatusDto.FormlyConfigTaskCountInProgress,
				ReadinessCategoryStatusDto.FormlyConfigTaskCountInComplete,
				ReadinessCategoryStatusDto.FormlyConfigTaskCountTotal,
				ReadinessCategoryStatusDto.FormlyConfigStatusPercentage,
				ReadinessCategoryStatusDto.FormlyConfigPercentComplete,
				ReadinessCategoryStatusDto.FormlyConfigPercentInProgress,
				ReadinessCategoryStatusDto.FormlyConfigPercentIncomplete
			];
		};
	}

	export class ReadinessDto {
		TaskNumber: string;
		TaskDescription: string;
		Scope: string;
		PriorityName: string;
		TaskOwner: string;
		DisciplineName: string;
		Contractor: string;
		TARApprovalName: string;
		HeightAccessName: string;
		Crane: string;
		HotWorkName: string;
		IsolationPlanName: string;
		WorkPackProcedureRequiredName: string;
		RevName: string;
		MaterialStatusName: string;
		LongLead: string;
		FabricationName: string;
		StagedOnSite: string;
		MOCRequired: string;
		MOCNumber: string;
		MOCStatusName: string;
		Comments: string;

		static get FormlyConfigTaskNumber() : FormlyFieldConfig {
			return {
			  "key": "TaskNumber",
			  "name": "TaskNumber",
			  "templateOptions": {
			    "label": "TaskNumber"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskDescription() : FormlyFieldConfig {
			return {
			  "key": "TaskDescription",
			  "name": "TaskDescription",
			  "templateOptions": {
			    "label": "TaskDescription"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigScope() : FormlyFieldConfig {
			return {
			  "key": "Scope",
			  "name": "Scope",
			  "templateOptions": {
			    "label": "Scope"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPriorityName() : FormlyFieldConfig {
			return {
			  "key": "PriorityName",
			  "name": "PriorityName",
			  "templateOptions": {
			    "label": "PriorityName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskOwner() : FormlyFieldConfig {
			return {
			  "key": "TaskOwner",
			  "name": "TaskOwner",
			  "templateOptions": {
			    "label": "TaskOwner"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDisciplineName() : FormlyFieldConfig {
			return {
			  "key": "DisciplineName",
			  "name": "DisciplineName",
			  "templateOptions": {
			    "label": "DisciplineName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigContractor() : FormlyFieldConfig {
			return {
			  "key": "Contractor",
			  "name": "Contractor",
			  "templateOptions": {
			    "label": "Contractor"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTARApprovalName() : FormlyFieldConfig {
			return {
			  "key": "TARApprovalName",
			  "name": "TARApprovalName",
			  "templateOptions": {
			    "label": "TARApprovalName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigHeightAccessName() : FormlyFieldConfig {
			return {
			  "key": "HeightAccessName",
			  "name": "HeightAccessName",
			  "templateOptions": {
			    "label": "HeightAccessName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCrane() : FormlyFieldConfig {
			return {
			  "key": "Crane",
			  "name": "Crane",
			  "templateOptions": {
			    "label": "Crane"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigHotWorkName() : FormlyFieldConfig {
			return {
			  "key": "HotWorkName",
			  "name": "HotWorkName",
			  "templateOptions": {
			    "label": "HotWorkName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsolationPlanName() : FormlyFieldConfig {
			return {
			  "key": "IsolationPlanName",
			  "name": "IsolationPlanName",
			  "templateOptions": {
			    "label": "IsolationPlanName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWorkPackProcedureRequiredName() : FormlyFieldConfig {
			return {
			  "key": "WorkPackProcedureRequiredName",
			  "name": "WorkPackProcedureRequiredName",
			  "templateOptions": {
			    "label": "WorkPackProcedureRequiredName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRevName() : FormlyFieldConfig {
			return {
			  "key": "RevName",
			  "name": "RevName",
			  "templateOptions": {
			    "label": "RevName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterialStatusName() : FormlyFieldConfig {
			return {
			  "key": "MaterialStatusName",
			  "name": "MaterialStatusName",
			  "templateOptions": {
			    "label": "MaterialStatusName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLongLead() : FormlyFieldConfig {
			return {
			  "key": "LongLead",
			  "name": "LongLead",
			  "templateOptions": {
			    "label": "LongLead"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFabricationName() : FormlyFieldConfig {
			return {
			  "key": "FabricationName",
			  "name": "FabricationName",
			  "templateOptions": {
			    "label": "FabricationName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStagedOnSite() : FormlyFieldConfig {
			return {
			  "key": "StagedOnSite",
			  "name": "StagedOnSite",
			  "templateOptions": {
			    "label": "StagedOnSite"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMOCRequired() : FormlyFieldConfig {
			return {
			  "key": "MOCRequired",
			  "name": "MOCRequired",
			  "templateOptions": {
			    "label": "MOCRequired"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMOCNumber() : FormlyFieldConfig {
			return {
			  "key": "MOCNumber",
			  "name": "MOCNumber",
			  "templateOptions": {
			    "label": "MOCNumber"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMOCStatusName() : FormlyFieldConfig {
			return {
			  "key": "MOCStatusName",
			  "name": "MOCStatusName",
			  "templateOptions": {
			    "label": "MOCStatusName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigComments() : FormlyFieldConfig {
			return {
			  "key": "Comments",
			  "name": "Comments",
			  "templateOptions": {
			    "label": "Comments"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessDto.FormlyConfigTaskNumber,
				ReadinessDto.FormlyConfigTaskDescription,
				ReadinessDto.FormlyConfigScope,
				ReadinessDto.FormlyConfigPriorityName,
				ReadinessDto.FormlyConfigTaskOwner,
				ReadinessDto.FormlyConfigDisciplineName,
				ReadinessDto.FormlyConfigContractor,
				ReadinessDto.FormlyConfigTARApprovalName,
				ReadinessDto.FormlyConfigHeightAccessName,
				ReadinessDto.FormlyConfigCrane,
				ReadinessDto.FormlyConfigHotWorkName,
				ReadinessDto.FormlyConfigIsolationPlanName,
				ReadinessDto.FormlyConfigWorkPackProcedureRequiredName,
				ReadinessDto.FormlyConfigRevName,
				ReadinessDto.FormlyConfigMaterialStatusName,
				ReadinessDto.FormlyConfigLongLead,
				ReadinessDto.FormlyConfigFabricationName,
				ReadinessDto.FormlyConfigStagedOnSite,
				ReadinessDto.FormlyConfigMOCRequired,
				ReadinessDto.FormlyConfigMOCNumber,
				ReadinessDto.FormlyConfigMOCStatusName,
				ReadinessDto.FormlyConfigComments
			];
		};
	}

	export class ReadinessSummaryDto {
		Project: ProjectDto = new ProjectDto();
		ReadinessFileLocation: string;
		Priorities: ReadinessTaskPriorityStatusDto[] = [];
		ProPakProjectUrl: string;
		PassThroughAuthKey: string;
		ProPakPassThroughFullUrl: string;
		PercentComplete: number;

		static get FormlyConfigProject() : FormlyFieldConfig {
			return {
			  "key": "Project",
			  "name": "Project",
			  "templateOptions": {
			    "type": "ProjectDto = new ProjectDto()",
			    "label": "Project"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigReadinessFileLocation() : FormlyFieldConfig {
			return {
			  "key": "ReadinessFileLocation",
			  "name": "ReadinessFileLocation",
			  "templateOptions": {
			    "label": "ReadinessFileLocation"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPriorities() : FormlyFieldConfig {
			return {
			  "key": "Priorities",
			  "name": "Priorities",
			  "templateOptions": {
			    "label": "Priorities",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigProPakProjectUrl() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectUrl",
			  "name": "ProPakProjectUrl",
			  "templateOptions": {
			    "label": "ProPakProjectUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPassThroughAuthKey() : FormlyFieldConfig {
			return {
			  "key": "PassThroughAuthKey",
			  "name": "PassThroughAuthKey",
			  "templateOptions": {
			    "label": "PassThroughAuthKey"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProPakPassThroughFullUrl() : FormlyFieldConfig {
			return {
			  "key": "ProPakPassThroughFullUrl",
			  "name": "ProPakPassThroughFullUrl",
			  "templateOptions": {
			    "label": "ProPakPassThroughFullUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessSummaryDto.FormlyConfigProject,
				ReadinessSummaryDto.FormlyConfigReadinessFileLocation,
				ReadinessSummaryDto.FormlyConfigPriorities,
				ReadinessSummaryDto.FormlyConfigProPakProjectUrl,
				ReadinessSummaryDto.FormlyConfigPassThroughAuthKey,
				ReadinessSummaryDto.FormlyConfigProPakPassThroughFullUrl,
				ReadinessSummaryDto.FormlyConfigPercentComplete
			];
		};
	}

	export class ReadinessTaskPriorityStatusDto {
		PriorityId: number;
		PriorityName: string;
		Categories: ReadinessCategoryStatusDto[] = [];
		TaskCountTotal: number;
		TaskCountComplete: number;
		PercentComplete: number;

		static get FormlyConfigPriorityId() : FormlyFieldConfig {
			return {
			  "key": "PriorityId",
			  "name": "PriorityId",
			  "templateOptions": {
			    "type": "number",
			    "label": "PriorityId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPriorityName() : FormlyFieldConfig {
			return {
			  "key": "PriorityName",
			  "name": "PriorityName",
			  "templateOptions": {
			    "label": "PriorityName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCategories() : FormlyFieldConfig {
			return {
			  "key": "Categories",
			  "name": "Categories",
			  "templateOptions": {
			    "label": "Categories",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigTaskCountTotal() : FormlyFieldConfig {
			return {
			  "key": "TaskCountTotal",
			  "name": "TaskCountTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountComplete() : FormlyFieldConfig {
			return {
			  "key": "TaskCountComplete",
			  "name": "TaskCountComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessTaskPriorityStatusDto.FormlyConfigPriorityId,
				ReadinessTaskPriorityStatusDto.FormlyConfigPriorityName,
				ReadinessTaskPriorityStatusDto.FormlyConfigCategories,
				ReadinessTaskPriorityStatusDto.FormlyConfigTaskCountTotal,
				ReadinessTaskPriorityStatusDto.FormlyConfigTaskCountComplete,
				ReadinessTaskPriorityStatusDto.FormlyConfigPercentComplete
			];
		};
	}

	export class RoleDto {
		Id: number;
		Name: string;
		Checkpoints: SecurityCheckpointDto[] = [];

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCheckpoints() : FormlyFieldConfig {
			return {
			  "key": "Checkpoints",
			  "name": "Checkpoints",
			  "templateOptions": {
			    "label": "Checkpoints",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				RoleDto.FormlyConfigId,
				RoleDto.FormlyConfigName,
				RoleDto.FormlyConfigCheckpoints
			];
		};
	}

	export class RoleSearchRow {
		Id: number;
		Name: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				RoleSearchRow.FormlyConfigId,
				RoleSearchRow.FormlyConfigName
			];
		};
	}

	export class SearchGridFormatTestSearchRow {
		Id: number;
		Name: string;
		Image: Blob;
		Checkbox: boolean;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigImage() : FormlyFieldConfig {
			return {
			  "key": "Image",
			  "name": "Image",
			  "templateOptions": {
			    "label": "Image",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigCheckbox() : FormlyFieldConfig {
			return {
			  "key": "Checkbox",
			  "name": "Checkbox",
			  "templateOptions": {
			    "label": "Checkbox"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SearchGridFormatTestSearchRow.FormlyConfigId,
				SearchGridFormatTestSearchRow.FormlyConfigName,
				SearchGridFormatTestSearchRow.FormlyConfigImage,
				SearchGridFormatTestSearchRow.FormlyConfigCheckbox
			];
		};
	}

	export class SearchTestSearchRow {
		Id: number;
		UserId: number;
		Name: string;
		BigInt: number;
		Date: Date;
		DateTime2: Date;
		DateTimeOffset: Date;
		Guid: string;
		Active: boolean;
		AddDate: Date;
		AddUser: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUserId() : FormlyFieldConfig {
			return {
			  "key": "UserId",
			  "name": "UserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "UserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBigInt() : FormlyFieldConfig {
			return {
			  "key": "BigInt",
			  "name": "BigInt",
			  "templateOptions": {
			    "type": "number",
			    "label": "BigInt"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDate() : FormlyFieldConfig {
			return {
			  "key": "Date",
			  "name": "Date",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Date"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDateTime2() : FormlyFieldConfig {
			return {
			  "key": "DateTime2",
			  "name": "DateTime2",
			  "templateOptions": {
			    "type": "Date",
			    "label": "DateTime2"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDateTimeOffset() : FormlyFieldConfig {
			return {
			  "key": "DateTimeOffset",
			  "name": "DateTimeOffset",
			  "templateOptions": {
			    "type": "Date",
			    "label": "DateTimeOffset"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigGuid() : FormlyFieldConfig {
			return {
			  "key": "Guid",
			  "name": "Guid",
			  "templateOptions": {
			    "label": "Guid"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigAddDate() : FormlyFieldConfig {
			return {
			  "key": "AddDate",
			  "name": "AddDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "AddDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAddUser() : FormlyFieldConfig {
			return {
			  "key": "AddUser",
			  "name": "AddUser",
			  "templateOptions": {
			    "label": "AddUser"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SearchTestSearchRow.FormlyConfigId,
				SearchTestSearchRow.FormlyConfigUserId,
				SearchTestSearchRow.FormlyConfigName,
				SearchTestSearchRow.FormlyConfigBigInt,
				SearchTestSearchRow.FormlyConfigDate,
				SearchTestSearchRow.FormlyConfigDateTime2,
				SearchTestSearchRow.FormlyConfigDateTimeOffset,
				SearchTestSearchRow.FormlyConfigGuid,
				SearchTestSearchRow.FormlyConfigActive,
				SearchTestSearchRow.FormlyConfigAddDate,
				SearchTestSearchRow.FormlyConfigAddUser
			];
		};
	}

	export class SecurityCheckpointDto {
		Id: number;
		CommandName: string;
		Description: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCommandName() : FormlyFieldConfig {
			return {
			  "key": "CommandName",
			  "name": "CommandName",
			  "templateOptions": {
			    "label": "CommandName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SecurityCheckpointDto.FormlyConfigId,
				SecurityCheckpointDto.FormlyConfigCommandName,
				SecurityCheckpointDto.FormlyConfigDescription
			];
		};
	}

	export class SiteSenseProjectDto {
		Id: number;
		Name: string;
		Description: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SiteSenseProjectDto.FormlyConfigId,
				SiteSenseProjectDto.FormlyConfigName,
				SiteSenseProjectDto.FormlyConfigDescription
			];
		};
	}

	export class StageDto {
		StageId: number;
		StageName: string;
		TaskCountTotal: number;
		TotalWeight: number;
		CompletedWeight: number;
		PercentComplete: number;
		DurationComplete: number;

		static get FormlyConfigStageId() : FormlyFieldConfig {
			return {
			  "key": "StageId",
			  "name": "StageId",
			  "templateOptions": {
			    "type": "number",
			    "label": "StageId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStageName() : FormlyFieldConfig {
			return {
			  "key": "StageName",
			  "name": "StageName",
			  "templateOptions": {
			    "label": "StageName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountTotal() : FormlyFieldConfig {
			return {
			  "key": "TaskCountTotal",
			  "name": "TaskCountTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalWeight() : FormlyFieldConfig {
			return {
			  "key": "TotalWeight",
			  "name": "TotalWeight",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalWeight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCompletedWeight() : FormlyFieldConfig {
			return {
			  "key": "CompletedWeight",
			  "name": "CompletedWeight",
			  "templateOptions": {
			    "type": "number",
			    "label": "CompletedWeight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDurationComplete() : FormlyFieldConfig {
			return {
			  "key": "DurationComplete",
			  "name": "DurationComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "DurationComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				StageDto.FormlyConfigStageId,
				StageDto.FormlyConfigStageName,
				StageDto.FormlyConfigTaskCountTotal,
				StageDto.FormlyConfigTotalWeight,
				StageDto.FormlyConfigCompletedWeight,
				StageDto.FormlyConfigPercentComplete,
				StageDto.FormlyConfigDurationComplete
			];
		};
	}

	export class StageStatusDto {
		Project: ProjectDto = new ProjectDto();
		TotalWeight: number;
		CompletedWeight: number;
		PercentComplete: number;
		SummaryStages: SummaryStageDto[] = [];

		static get FormlyConfigProject() : FormlyFieldConfig {
			return {
			  "key": "Project",
			  "name": "Project",
			  "templateOptions": {
			    "type": "ProjectDto = new ProjectDto()",
			    "label": "Project"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalWeight() : FormlyFieldConfig {
			return {
			  "key": "TotalWeight",
			  "name": "TotalWeight",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalWeight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCompletedWeight() : FormlyFieldConfig {
			return {
			  "key": "CompletedWeight",
			  "name": "CompletedWeight",
			  "templateOptions": {
			    "type": "number",
			    "label": "CompletedWeight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSummaryStages() : FormlyFieldConfig {
			return {
			  "key": "SummaryStages",
			  "name": "SummaryStages",
			  "templateOptions": {
			    "label": "SummaryStages",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				StageStatusDto.FormlyConfigProject,
				StageStatusDto.FormlyConfigTotalWeight,
				StageStatusDto.FormlyConfigCompletedWeight,
				StageStatusDto.FormlyConfigPercentComplete,
				StageStatusDto.FormlyConfigSummaryStages
			];
		};
	}

	export class SummaryPriorityDto {
		PriorityId: number;
		PriorityName: string;
		TaskCountTotal: number;
		TaskCountCompleted: number;
		TaskCountIncomplete: number;

		static get FormlyConfigPriorityId() : FormlyFieldConfig {
			return {
			  "key": "PriorityId",
			  "name": "PriorityId",
			  "templateOptions": {
			    "type": "number",
			    "label": "PriorityId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPriorityName() : FormlyFieldConfig {
			return {
			  "key": "PriorityName",
			  "name": "PriorityName",
			  "templateOptions": {
			    "label": "PriorityName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountTotal() : FormlyFieldConfig {
			return {
			  "key": "TaskCountTotal",
			  "name": "TaskCountTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountCompleted() : FormlyFieldConfig {
			return {
			  "key": "TaskCountCompleted",
			  "name": "TaskCountCompleted",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountCompleted"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountIncomplete() : FormlyFieldConfig {
			return {
			  "key": "TaskCountIncomplete",
			  "name": "TaskCountIncomplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountIncomplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SummaryPriorityDto.FormlyConfigPriorityId,
				SummaryPriorityDto.FormlyConfigPriorityName,
				SummaryPriorityDto.FormlyConfigTaskCountTotal,
				SummaryPriorityDto.FormlyConfigTaskCountCompleted,
				SummaryPriorityDto.FormlyConfigTaskCountIncomplete
			];
		};
	}

	export class SummaryStageDto {
		SummaryStageId: number;
		StageName: string;
		TaskCountTotal: number;
		TotalWeight: number;
		CompletedWeight: number;
		DurationPercentComplete: number;
		PercentComplete: number;
		Stages: StageDto[] = [];

		static get FormlyConfigSummaryStageId() : FormlyFieldConfig {
			return {
			  "key": "SummaryStageId",
			  "name": "SummaryStageId",
			  "templateOptions": {
			    "type": "number",
			    "label": "SummaryStageId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStageName() : FormlyFieldConfig {
			return {
			  "key": "StageName",
			  "name": "StageName",
			  "templateOptions": {
			    "label": "StageName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountTotal() : FormlyFieldConfig {
			return {
			  "key": "TaskCountTotal",
			  "name": "TaskCountTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalWeight() : FormlyFieldConfig {
			return {
			  "key": "TotalWeight",
			  "name": "TotalWeight",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalWeight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCompletedWeight() : FormlyFieldConfig {
			return {
			  "key": "CompletedWeight",
			  "name": "CompletedWeight",
			  "templateOptions": {
			    "type": "number",
			    "label": "CompletedWeight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDurationPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "DurationPercentComplete",
			  "name": "DurationPercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "DurationPercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStages() : FormlyFieldConfig {
			return {
			  "key": "Stages",
			  "name": "Stages",
			  "templateOptions": {
			    "label": "Stages",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SummaryStageDto.FormlyConfigSummaryStageId,
				SummaryStageDto.FormlyConfigStageName,
				SummaryStageDto.FormlyConfigTaskCountTotal,
				SummaryStageDto.FormlyConfigTotalWeight,
				SummaryStageDto.FormlyConfigCompletedWeight,
				SummaryStageDto.FormlyConfigDurationPercentComplete,
				SummaryStageDto.FormlyConfigPercentComplete,
				SummaryStageDto.FormlyConfigStages
			];
		};
	}

	export class TaskDto {
		id: number;
		text: string;
		start_date: string;
		duration: number;
		progress: number;
		type: string;
		parent: number;
		open: boolean;
		end_date: string;
		editable: boolean;

		static get FormlyConfigid() : FormlyFieldConfig {
			return {
			  "key": "id",
			  "name": "id",
			  "templateOptions": {
			    "type": "number",
			    "label": "id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigtext() : FormlyFieldConfig {
			return {
			  "key": "text",
			  "name": "text",
			  "templateOptions": {
			    "label": "text"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigstart_date() : FormlyFieldConfig {
			return {
			  "key": "start_date",
			  "name": "start_date",
			  "templateOptions": {
			    "label": "start_date"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigduration() : FormlyFieldConfig {
			return {
			  "key": "duration",
			  "name": "duration",
			  "templateOptions": {
			    "type": "number",
			    "label": "duration"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigprogress() : FormlyFieldConfig {
			return {
			  "key": "progress",
			  "name": "progress",
			  "templateOptions": {
			    "type": "number",
			    "label": "progress"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigtype() : FormlyFieldConfig {
			return {
			  "key": "type",
			  "name": "type",
			  "templateOptions": {
			    "label": "type"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigparent() : FormlyFieldConfig {
			return {
			  "key": "parent",
			  "name": "parent",
			  "templateOptions": {
			    "type": "number",
			    "label": "parent"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigopen() : FormlyFieldConfig {
			return {
			  "key": "open",
			  "name": "open",
			  "templateOptions": {
			    "label": "open"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigend_date() : FormlyFieldConfig {
			return {
			  "key": "end_date",
			  "name": "end_date",
			  "templateOptions": {
			    "label": "end_date"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigeditable() : FormlyFieldConfig {
			return {
			  "key": "editable",
			  "name": "editable",
			  "templateOptions": {
			    "label": "editable"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				TaskDto.FormlyConfigid,
				TaskDto.FormlyConfigtext,
				TaskDto.FormlyConfigstart_date,
				TaskDto.FormlyConfigduration,
				TaskDto.FormlyConfigprogress,
				TaskDto.FormlyConfigtype,
				TaskDto.FormlyConfigparent,
				TaskDto.FormlyConfigopen,
				TaskDto.FormlyConfigend_date,
				TaskDto.FormlyConfigeditable
			];
		};
	}

	export class UserDto {
		Id: number;
		Username: string;
		FirstName: string;
		LastName: string;
		Email: string;
		Active: boolean;
		LogCommands: boolean;
		UserRoleDtos: UserRoleDto[] = [];

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUsername() : FormlyFieldConfig {
			return {
			  "key": "Username",
			  "name": "Username",
			  "templateOptions": {
			    "label": "Username"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFirstName() : FormlyFieldConfig {
			return {
			  "key": "FirstName",
			  "name": "FirstName",
			  "templateOptions": {
			    "label": "FirstName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLastName() : FormlyFieldConfig {
			return {
			  "key": "LastName",
			  "name": "LastName",
			  "templateOptions": {
			    "label": "LastName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigEmail() : FormlyFieldConfig {
			return {
			  "key": "Email",
			  "name": "Email",
			  "templateOptions": {
			    "label": "Email"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigLogCommands() : FormlyFieldConfig {
			return {
			  "key": "LogCommands",
			  "name": "LogCommands",
			  "templateOptions": {
			    "label": "LogCommands"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigUserRoleDtos() : FormlyFieldConfig {
			return {
			  "key": "UserRoleDtos",
			  "name": "UserRoleDtos",
			  "templateOptions": {
			    "label": "UserRoleDtos",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UserDto.FormlyConfigId,
				UserDto.FormlyConfigUsername,
				UserDto.FormlyConfigFirstName,
				UserDto.FormlyConfigLastName,
				UserDto.FormlyConfigEmail,
				UserDto.FormlyConfigActive,
				UserDto.FormlyConfigLogCommands,
				UserDto.FormlyConfigUserRoleDtos
			];
		};
	}

	export class UserInfoDto {
		Id: number;
		UserName: string;
		FirstName: string;
		LastName: string;
		Roles: ValueTextDto[] = [];
		EmailAddress: string;
		LogCommands: boolean;
		Checkpoints: CommandSecurityCheckpointDto[] = [];

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUserName() : FormlyFieldConfig {
			return {
			  "key": "UserName",
			  "name": "UserName",
			  "templateOptions": {
			    "label": "UserName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFirstName() : FormlyFieldConfig {
			return {
			  "key": "FirstName",
			  "name": "FirstName",
			  "templateOptions": {
			    "label": "FirstName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLastName() : FormlyFieldConfig {
			return {
			  "key": "LastName",
			  "name": "LastName",
			  "templateOptions": {
			    "label": "LastName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRoles() : FormlyFieldConfig {
			return {
			  "key": "Roles",
			  "name": "Roles",
			  "templateOptions": {
			    "label": "Roles",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigEmailAddress() : FormlyFieldConfig {
			return {
			  "key": "EmailAddress",
			  "name": "EmailAddress",
			  "templateOptions": {
			    "label": "EmailAddress"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLogCommands() : FormlyFieldConfig {
			return {
			  "key": "LogCommands",
			  "name": "LogCommands",
			  "templateOptions": {
			    "label": "LogCommands"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigCheckpoints() : FormlyFieldConfig {
			return {
			  "key": "Checkpoints",
			  "name": "Checkpoints",
			  "templateOptions": {
			    "label": "Checkpoints",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UserInfoDto.FormlyConfigId,
				UserInfoDto.FormlyConfigUserName,
				UserInfoDto.FormlyConfigFirstName,
				UserInfoDto.FormlyConfigLastName,
				UserInfoDto.FormlyConfigRoles,
				UserInfoDto.FormlyConfigEmailAddress,
				UserInfoDto.FormlyConfigLogCommands,
				UserInfoDto.FormlyConfigCheckpoints
			];
		};
	}

	export class UserRoleDto {
		RoleId: number;
		RoleName: string;
		IsSelected: boolean;

		static get FormlyConfigRoleId() : FormlyFieldConfig {
			return {
			  "key": "RoleId",
			  "name": "RoleId",
			  "templateOptions": {
			    "type": "number",
			    "label": "RoleId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRoleName() : FormlyFieldConfig {
			return {
			  "key": "RoleName",
			  "name": "RoleName",
			  "templateOptions": {
			    "label": "RoleName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsSelected() : FormlyFieldConfig {
			return {
			  "key": "IsSelected",
			  "name": "IsSelected",
			  "templateOptions": {
			    "label": "IsSelected"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UserRoleDto.FormlyConfigRoleId,
				UserRoleDto.FormlyConfigRoleName,
				UserRoleDto.FormlyConfigIsSelected
			];
		};
	}

	export class UserSearchRow {
		Id: number;
		FirstName: string;
		LastName: string;
		Email: string;
		Active: boolean;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFirstName() : FormlyFieldConfig {
			return {
			  "key": "FirstName",
			  "name": "FirstName",
			  "templateOptions": {
			    "label": "FirstName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLastName() : FormlyFieldConfig {
			return {
			  "key": "LastName",
			  "name": "LastName",
			  "templateOptions": {
			    "label": "LastName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigEmail() : FormlyFieldConfig {
			return {
			  "key": "Email",
			  "name": "Email",
			  "templateOptions": {
			    "label": "Email"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UserSearchRow.FormlyConfigId,
				UserSearchRow.FormlyConfigFirstName,
				UserSearchRow.FormlyConfigLastName,
				UserSearchRow.FormlyConfigEmail,
				UserSearchRow.FormlyConfigActive
			];
		};
	}

	export class ValueLabelDto {
		value: any;
		label: string;

		static get FormlyConfigvalue() : FormlyFieldConfig {
			return {
			  "key": "value",
			  "name": "value",
			  "templateOptions": {
			    "type": "any",
			    "label": "value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfiglabel() : FormlyFieldConfig {
			return {
			  "key": "label",
			  "name": "label",
			  "templateOptions": {
			    "label": "label"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ValueLabelDto.FormlyConfigvalue,
				ValueLabelDto.FormlyConfiglabel
			];
		};
	}

	export class ValueSelectedDto {
		Value: any;
		Selected: boolean;

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "any",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSelected() : FormlyFieldConfig {
			return {
			  "key": "Selected",
			  "name": "Selected",
			  "templateOptions": {
			    "label": "Selected"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ValueSelectedDto.FormlyConfigValue,
				ValueSelectedDto.FormlyConfigSelected
			];
		};
	}

	export class ValueTextDescriptionDto {
		Value: any;
		Text: string;
		Description: string;

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "any",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigText() : FormlyFieldConfig {
			return {
			  "key": "Text",
			  "name": "Text",
			  "templateOptions": {
			    "label": "Text"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ValueTextDescriptionDto.FormlyConfigValue,
				ValueTextDescriptionDto.FormlyConfigText,
				ValueTextDescriptionDto.FormlyConfigDescription
			];
		};
	}

	export class ValueTextDto {
		Value: any;
		Text: string;

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "any",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigText() : FormlyFieldConfig {
			return {
			  "key": "Text",
			  "name": "Text",
			  "templateOptions": {
			    "label": "Text"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ValueTextDto.FormlyConfigValue,
				ValueTextDto.FormlyConfigText
			];
		};
	}

	export class ValueTextSelectedDto {
		Value: any;
		Text: string;
		Selected: boolean;

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "any",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigText() : FormlyFieldConfig {
			return {
			  "key": "Text",
			  "name": "Text",
			  "templateOptions": {
			    "label": "Text"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSelected() : FormlyFieldConfig {
			return {
			  "key": "Selected",
			  "name": "Selected",
			  "templateOptions": {
			    "label": "Selected"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ValueTextSelectedDto.FormlyConfigValue,
				ValueTextSelectedDto.FormlyConfigText,
				ValueTextSelectedDto.FormlyConfigSelected
			];
		};
	}

	export class WidgetDto {
		Id: number;
		Order: number;
		WidgetType: WidgetType;
		Selected: boolean;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWidgetType() : FormlyFieldConfig {
			return {
			  "key": "WidgetType",
			  "name": "WidgetType",
			  "templateOptions": {
			    "type": "WidgetType = new WidgetType()",
			    "label": "WidgetType",
			    "options": [
			      {
			        "label": "Count",
			        "value": "0"
			      }
			    ]
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSelected() : FormlyFieldConfig {
			return {
			  "key": "Selected",
			  "name": "Selected",
			  "templateOptions": {
			    "label": "Selected"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				WidgetDto.FormlyConfigId,
				WidgetDto.FormlyConfigOrder,
				WidgetDto.FormlyConfigWidgetType,
				WidgetDto.FormlyConfigSelected
			];
		};
	}

	export class AdminCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class CreateTestDummyCommandQueueCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class CreateUserCommandRequest {
		Username: string;
		Password: string;
		FirstName: string;
		LastName: string;
		Email: string;
		Roles: ValueTextDto[] = [];

		static get FormlyConfigUsername() : FormlyFieldConfig {
			return {
			  "key": "Username",
			  "name": "Username",
			  "templateOptions": {
			    "label": "Username"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPassword() : FormlyFieldConfig {
			return {
			  "key": "Password",
			  "name": "Password",
			  "templateOptions": {
			    "label": "Password"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFirstName() : FormlyFieldConfig {
			return {
			  "key": "FirstName",
			  "name": "FirstName",
			  "templateOptions": {
			    "label": "FirstName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLastName() : FormlyFieldConfig {
			return {
			  "key": "LastName",
			  "name": "LastName",
			  "templateOptions": {
			    "label": "LastName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigEmail() : FormlyFieldConfig {
			return {
			  "key": "Email",
			  "name": "Email",
			  "templateOptions": {
			    "label": "Email"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRoles() : FormlyFieldConfig {
			return {
			  "key": "Roles",
			  "name": "Roles",
			  "templateOptions": {
			    "label": "Roles",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CreateUserCommandRequest.FormlyConfigUsername,
				CreateUserCommandRequest.FormlyConfigPassword,
				CreateUserCommandRequest.FormlyConfigFirstName,
				CreateUserCommandRequest.FormlyConfigLastName,
				CreateUserCommandRequest.FormlyConfigEmail,
				CreateUserCommandRequest.FormlyConfigRoles
			];
		};
	}

	export class DeleteCheckpointCommandRequest {
		CommandSecurityRoleId: number;

		static get FormlyConfigCommandSecurityRoleId() : FormlyFieldConfig {
			return {
			  "key": "CommandSecurityRoleId",
			  "name": "CommandSecurityRoleId",
			  "templateOptions": {
			    "type": "number",
			    "label": "CommandSecurityRoleId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DeleteCheckpointCommandRequest.FormlyConfigCommandSecurityRoleId
			];
		};
	}

	export class DeleteExampleCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DeleteExampleCommandRequest.FormlyConfigId
			];
		};
	}

	export class DeleteRoleCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DeleteRoleCommandRequest.FormlyConfigId
			];
		};
	}

	export class ExecuteAllPendingQueuesCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class ExecuteNextQueueEntryCommandRequest {
		QueueDefinition: BatchProcessingQueueDefinition;
		QueueEntryId: number;

		static get FormlyConfigQueueDefinition() : FormlyFieldConfig {
			return {
			  "key": "QueueDefinition",
			  "name": "QueueDefinition",
			  "templateOptions": {
			    "type": "BatchProcessingQueueDefinition = new BatchProcessingQueueDefinition()",
			    "label": "QueueDefinition"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigQueueEntryId() : FormlyFieldConfig {
			return {
			  "key": "QueueEntryId",
			  "name": "QueueEntryId",
			  "templateOptions": {
			    "type": "number",
			    "label": "QueueEntryId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecuteNextQueueEntryCommandRequest.FormlyConfigQueueDefinition,
				ExecuteNextQueueEntryCommandRequest.FormlyConfigQueueEntryId
			];
		};
	}

	export class ExecutePendingQueueEntriesCommandRequest {
		QueueDefinition: BatchProcessingQueueDefinition;

		static get FormlyConfigQueueDefinition() : FormlyFieldConfig {
			return {
			  "key": "QueueDefinition",
			  "name": "QueueDefinition",
			  "templateOptions": {
			    "type": "BatchProcessingQueueDefinition = new BatchProcessingQueueDefinition()",
			    "label": "QueueDefinition",
			    "options": [
			      {
			        "label": "TestDummy",
			        "value": "1"
			      },
			      {
			        "label": "Email",
			        "value": "2"
			      }
			    ]
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecutePendingQueueEntriesCommandRequest.FormlyConfigQueueDefinition
			];
		};
	}

	export class GetApplicationSettingCommandRequest {
		SettingName: string;

		static get FormlyConfigSettingName() : FormlyFieldConfig {
			return {
			  "key": "SettingName",
			  "name": "SettingName",
			  "templateOptions": {
			    "label": "SettingName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetApplicationSettingCommandRequest.FormlyConfigSettingName
			];
		};
	}

	export class GetCheckpointCommandRequest {
		SecurityCheckpointId: number;

		static get FormlyConfigSecurityCheckpointId() : FormlyFieldConfig {
			return {
			  "key": "SecurityCheckpointId",
			  "name": "SecurityCheckpointId",
			  "templateOptions": {
			    "type": "number",
			    "label": "SecurityCheckpointId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetCheckpointCommandRequest.FormlyConfigSecurityCheckpointId
			];
		};
	}

	export class GetClientAndAssetListByUserCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class GetCountryCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetCountryCommandRequest.FormlyConfigId
			];
		};
	}

	export class GetDashboardCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class GetExampleCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetExampleCommandRequest.FormlyConfigId
			];
		};
	}

	export class GetExceptionCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetExceptionCommandRequest.FormlyConfigId
			];
		};
	}

	export class GetExecutionBarChartCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetExecutionBarChartCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetExecutionChartCommandRequest {
		ProjectId: number;
		StartDate: Date;
		EndDate: Date;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStartDate() : FormlyFieldConfig {
			return {
			  "key": "StartDate",
			  "name": "StartDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "StartDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigEndDate() : FormlyFieldConfig {
			return {
			  "key": "EndDate",
			  "name": "EndDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "EndDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetExecutionChartCommandRequest.FormlyConfigProjectId,
				GetExecutionChartCommandRequest.FormlyConfigStartDate,
				GetExecutionChartCommandRequest.FormlyConfigEndDate
			];
		};
	}

	export class GetExecutionCurrentStatusChartCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetExecutionCurrentStatusChartCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetExecutionStatusCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetExecutionStatusCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetMaterialsStatusCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetMaterialsStatusCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetPrimaveraSummaryReportCommandRequest {
		ProPakProjectId: number;

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetPrimaveraSummaryReportCommandRequest.FormlyConfigProPakProjectId
			];
		};
	}

	export class GetProjectModuleDisplaySettingsCommandRequest {
		ProPakProjectId: number;

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetProjectModuleDisplaySettingsCommandRequest.FormlyConfigProPakProjectId
			];
		};
	}

	export class GetProjectsByUserCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class GetProjectSetupCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetProjectSetupCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetQueueDetailCommandRequest {
		QueueName: string;

		static get FormlyConfigQueueName() : FormlyFieldConfig {
			return {
			  "key": "QueueName",
			  "name": "QueueName",
			  "templateOptions": {
			    "label": "QueueName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetQueueDetailCommandRequest.FormlyConfigQueueName
			];
		};
	}

	export class GetReadinessStatusCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetReadinessStatusCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetReadinessSummaryCommandRequest {
		ProjectId: number;
		ProPakProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetReadinessSummaryCommandRequest.FormlyConfigProjectId,
				GetReadinessSummaryCommandRequest.FormlyConfigProPakProjectId
			];
		};
	}

	export class GetReleaseNumberCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class GetRoleCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetRoleCommandRequest.FormlyConfigId
			];
		};
	}

	export class GetTaskPriorityStatusCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetTaskPriorityStatusCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetUserCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetUserCommandRequest.FormlyConfigId
			];
		};
	}

	export class GetUserWidgetSelectionsCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class ImportPrimaveraP6CommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class ImportReadinessToolCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class ImportSiteSenseCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class IsUserAuthenticatedCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class LoginCommandRequest {
		Username: string;
		Password: string;
		ServiceToken: string;

		static get FormlyConfigUsername() : FormlyFieldConfig {
			return {
			  "key": "Username",
			  "name": "Username",
			  "templateOptions": {
			    "label": "Username"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPassword() : FormlyFieldConfig {
			return {
			  "key": "Password",
			  "name": "Password",
			  "templateOptions": {
			    "label": "Password"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigServiceToken() : FormlyFieldConfig {
			return {
			  "key": "ServiceToken",
			  "name": "ServiceToken",
			  "templateOptions": {
			    "label": "ServiceToken"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				LoginCommandRequest.FormlyConfigUsername,
				LoginCommandRequest.FormlyConfigPassword,
				LoginCommandRequest.FormlyConfigServiceToken
			];
		};
	}

	export class LogoutCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class LogTypeScriptErrorCommandRequest {
		Message: string;
		Type: string;
		Url: string;
		Stack: string;

		static get FormlyConfigMessage() : FormlyFieldConfig {
			return {
			  "key": "Message",
			  "name": "Message",
			  "templateOptions": {
			    "label": "Message"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigType() : FormlyFieldConfig {
			return {
			  "key": "Type",
			  "name": "Type",
			  "templateOptions": {
			    "label": "Type"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUrl() : FormlyFieldConfig {
			return {
			  "key": "Url",
			  "name": "Url",
			  "templateOptions": {
			    "label": "Url"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStack() : FormlyFieldConfig {
			return {
			  "key": "Stack",
			  "name": "Stack",
			  "templateOptions": {
			    "label": "Stack"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				LogTypeScriptErrorCommandRequest.FormlyConfigMessage,
				LogTypeScriptErrorCommandRequest.FormlyConfigType,
				LogTypeScriptErrorCommandRequest.FormlyConfigUrl,
				LogTypeScriptErrorCommandRequest.FormlyConfigStack
			];
		};
	}

	export class PersistProjectSetupCommandRequest {
		ProjectInfo: ProjectSetupDto = new ProjectSetupDto();

		static get FormlyConfigProjectInfo() : FormlyFieldConfig {
			return {
			  "key": "ProjectInfo",
			  "name": "ProjectInfo",
			  "templateOptions": {
			    "type": "ProjectSetupDto = new ProjectSetupDto()",
			    "label": "ProjectInfo"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				PersistProjectSetupCommandRequest.FormlyConfigProjectInfo
			];
		};
	}

	export class SaveApplicationSettingCommandRequest {
		Id: number;
		Name: string;
		Value: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveApplicationSettingCommandRequest.FormlyConfigId,
				SaveApplicationSettingCommandRequest.FormlyConfigName,
				SaveApplicationSettingCommandRequest.FormlyConfigValue
			];
		};
	}

	export class SaveCheckpointCommandRequest {
		Roles: ValueTextSelectedDto[] = [];
		SecurityCheckpoint: SecurityCheckpointDto = new SecurityCheckpointDto();

		static get FormlyConfigRoles() : FormlyFieldConfig {
			return {
			  "key": "Roles",
			  "name": "Roles",
			  "templateOptions": {
			    "label": "Roles",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigSecurityCheckpoint() : FormlyFieldConfig {
			return {
			  "key": "SecurityCheckpoint",
			  "name": "SecurityCheckpoint",
			  "templateOptions": {
			    "type": "SecurityCheckpointDto = new SecurityCheckpointDto()",
			    "label": "SecurityCheckpoint"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveCheckpointCommandRequest.FormlyConfigRoles,
				SaveCheckpointCommandRequest.FormlyConfigSecurityCheckpoint
			];
		};
	}

	export class SaveCountryCommandRequest {
		Country: CountryDto = new CountryDto();

		static get FormlyConfigCountry() : FormlyFieldConfig {
			return {
			  "key": "Country",
			  "name": "Country",
			  "templateOptions": {
			    "type": "CountryDto = new CountryDto()",
			    "label": "Country"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveCountryCommandRequest.FormlyConfigCountry
			];
		};
	}

	export class SaveExampleCommandRequest {
		Id: number;
		DisplayText: string;
		Value: string;
		ExampleLookupId: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDisplayText() : FormlyFieldConfig {
			return {
			  "key": "DisplayText",
			  "name": "DisplayText",
			  "templateOptions": {
			    "label": "DisplayText"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigExampleLookupId() : FormlyFieldConfig {
			return {
			  "key": "ExampleLookupId",
			  "name": "ExampleLookupId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ExampleLookupId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveExampleCommandRequest.FormlyConfigId,
				SaveExampleCommandRequest.FormlyConfigDisplayText,
				SaveExampleCommandRequest.FormlyConfigValue,
				SaveExampleCommandRequest.FormlyConfigExampleLookupId
			];
		};
	}

	export class SaveFormlyExampleCommandRequest {
		Id: number;
		DisplayText: string;
		Value: string;
		ExampleLookupId: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDisplayText() : FormlyFieldConfig {
			return {
			  "key": "DisplayText",
			  "name": "DisplayText",
			  "templateOptions": {
			    "label": "DisplayText"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigExampleLookupId() : FormlyFieldConfig {
			return {
			  "key": "ExampleLookupId",
			  "name": "ExampleLookupId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ExampleLookupId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveFormlyExampleCommandRequest.FormlyConfigId,
				SaveFormlyExampleCommandRequest.FormlyConfigDisplayText,
				SaveFormlyExampleCommandRequest.FormlyConfigValue,
				SaveFormlyExampleCommandRequest.FormlyConfigExampleLookupId
			];
		};
	}

	export class SaveRoleCommandRequest {
		Role: RoleDto = new RoleDto();
		RoleWidgets: ValueTextSelectedDto[] = [];

		static get FormlyConfigRole() : FormlyFieldConfig {
			return {
			  "key": "Role",
			  "name": "Role",
			  "templateOptions": {
			    "type": "RoleDto = new RoleDto()",
			    "label": "Role"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRoleWidgets() : FormlyFieldConfig {
			return {
			  "key": "RoleWidgets",
			  "name": "RoleWidgets",
			  "templateOptions": {
			    "label": "RoleWidgets",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveRoleCommandRequest.FormlyConfigRole,
				SaveRoleCommandRequest.FormlyConfigRoleWidgets
			];
		};
	}

	export class SaveUserCommandRequest {
		UserDto: UserDto = new UserDto();

		static get FormlyConfigUserDto() : FormlyFieldConfig {
			return {
			  "key": "UserDto",
			  "name": "UserDto",
			  "templateOptions": {
			    "type": "UserDto = new UserDto()",
			    "label": "UserDto"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveUserCommandRequest.FormlyConfigUserDto
			];
		};
	}

	export class SaveUserWidgetOrderCommandRequest {
		WidgetIds: number[] = [];

		static get FormlyConfigWidgetIds() : FormlyFieldConfig {
			return {
			  "key": "WidgetIds",
			  "name": "WidgetIds",
			  "templateOptions": {
			    "label": "WidgetIds",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveUserWidgetOrderCommandRequest.FormlyConfigWidgetIds
			];
		};
	}

	export class SaveUserWidgetSelectionsCommandRequest {
		SelectedWidgetIds: number[] = [];

		static get FormlyConfigSelectedWidgetIds() : FormlyFieldConfig {
			return {
			  "key": "SelectedWidgetIds",
			  "name": "SelectedWidgetIds",
			  "templateOptions": {
			    "label": "SelectedWidgetIds",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveUserWidgetSelectionsCommandRequest.FormlyConfigSelectedWidgetIds
			];
		};
	}

	export class SearchObjectsCommandRequest {
		SearchCriteria: SearchCriteria = new SearchCriteria();
		Objects: any[] = [];

		static get FormlyConfigSearchCriteria() : FormlyFieldConfig {
			return {
			  "key": "SearchCriteria",
			  "name": "SearchCriteria",
			  "templateOptions": {
			    "type": "SearchCriteria = new SearchCriteria()",
			    "label": "SearchCriteria"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigObjects() : FormlyFieldConfig {
			return {
			  "key": "Objects",
			  "name": "Objects",
			  "templateOptions": {
			    "label": "Objects",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SearchObjectsCommandRequest.FormlyConfigSearchCriteria,
				SearchObjectsCommandRequest.FormlyConfigObjects
			];
		};
	}

	export class TestDummyCommandRequest {
		MyString: string;
		MyInt: number;
		MyNullableInt: number;

		static get FormlyConfigMyString() : FormlyFieldConfig {
			return {
			  "key": "MyString",
			  "name": "MyString",
			  "templateOptions": {
			    "label": "MyString"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMyInt() : FormlyFieldConfig {
			return {
			  "key": "MyInt",
			  "name": "MyInt",
			  "templateOptions": {
			    "type": "number",
			    "label": "MyInt"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMyNullableInt() : FormlyFieldConfig {
			return {
			  "key": "MyNullableInt",
			  "name": "MyNullableInt",
			  "templateOptions": {
			    "type": "number",
			    "label": "MyNullableInt"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				TestDummyCommandRequest.FormlyConfigMyString,
				TestDummyCommandRequest.FormlyConfigMyInt,
				TestDummyCommandRequest.FormlyConfigMyNullableInt
			];
		};
	}

	export class TriggerServerExceptionCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class UnusedSecurityCheckpointSearchCommandRequest {
		SearchType: string;
		SearchCriteria: SearchCriteria = new SearchCriteria();

		static get FormlyConfigSearchType() : FormlyFieldConfig {
			return {
			  "key": "SearchType",
			  "name": "SearchType",
			  "templateOptions": {
			    "label": "SearchType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSearchCriteria() : FormlyFieldConfig {
			return {
			  "key": "SearchCriteria",
			  "name": "SearchCriteria",
			  "templateOptions": {
			    "type": "SearchCriteria = new SearchCriteria()",
			    "label": "SearchCriteria"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UnusedSecurityCheckpointSearchCommandRequest.FormlyConfigSearchType,
				UnusedSecurityCheckpointSearchCommandRequest.FormlyConfigSearchCriteria
			];
		};
	}

	export class AdminCommandResponse {
	}

	export class CreateTestDummyCommandQueueCommandResponse {
	}

	export class CreateUserCommandResponse {
	}

	export class DeleteCheckpointCommandResponse {
	}

	export class DeleteRoleCommandResponse {
	}

	export class ExecuteAllPendingQueuesCommandResponse {
	}

	export class ExecuteNextQueueEntryCommandResponse {
		ProcessedQueueEntryId: number;
		WasAQueueEntryProcessed: boolean;
	}

	export class ExecutePendingQueueEntriesCommandResponse {
	}

	export class GetApplicationSettingCommandResponse {
		Id: number;
		Name: string;
		Value: string;
	}

	export class GetCheckpointCommandResponse {
		Roles: ValueTextSelectedDto[] = [];
		SecurityCheckpoint: SecurityCheckpointDto = new SecurityCheckpointDto();
	}

	export class GetClientAndAssetListByUserCommandResponse {
		AssetList: AssetDto[] = [];
		ClientList: ClientDto[] = [];
	}

	export class GetCountryCommandResponse {
		Country: CountryDto = new CountryDto();
	}

	export class GetDashboardCommandResponse {
		Dashboard: DashboardDto = new DashboardDto();
	}

	export class GetExampleCommandResponse {
		Id: number;
		DisplayText: string;
		Value: string;
		ExampleLookupId: number;
		ExampleLookups: ValueLabelDto[] = [];
	}

	export class GetExceptionCommandResponse {
		Id: number;
		CreationDate: string;
		ApplicationName: string;
		MachineName: string;
		Type: string;
		User: string;
		URL: string;
		HTTPMethod: string;
		Message: string;
		Detail: string;
	}

	export class GetExecutionBarChartCommandResponse {
		Data: ExecutionChartDataSeriesDto[] = [];
	}

	export class GetExecutionChartCommandResponse {
		Data: ExecutionScheduleDto = new ExecutionScheduleDto();
	}

	export class GetExecutionCurrentStatusChartCommandResponse {
		Data: ExecutionBarChartDto = new ExecutionBarChartDto();
	}

	export class GetExecutionStatusCommandResponse {
		Execution: ExecutionSummaryDto = new ExecutionSummaryDto();
	}

	export class GetMaterialsStatusCommandResponse {
		Materials: MaterialsStageStatusDto = new MaterialsStageStatusDto();
	}

	export class GetPrimaveraSummaryReportCommandResponse {
		Data: TaskDto[] = [];
		Links: LinkDto[] = [];
	}

	export class GetProjectModuleDisplaySettingsCommandResponse {
		ModuleDisplaySettings: ModuleDisplaySettingDto = new ModuleDisplaySettingDto();
	}

	export class GetProjectsByUserCommandResponse {
		Projects: ProjectDto[] = [];
		AssetList: AssetDto[] = [];
		ClientList: ClientDto[] = [];
		UserRoles: UserRoleDto[] = [];
	}

	export class GetProjectSetupCommandResponse {
		ProjectInfo: ProjectSetupDto = new ProjectSetupDto();
	}

	export class GetQueueDetailCommandResponse {
	}

	export class GetReadinessStatusCommandResponse {
		Readiness: StageStatusDto = new StageStatusDto();
	}

	export class GetReadinessSummaryCommandResponse {
		ReadinessSummary: ReadinessSummaryDto = new ReadinessSummaryDto();
	}

	export class GetReleaseNumberCommandResponse {
		ReleaseId: string;
	}

	export class GetRoleCommandResponse {
		Role: RoleDto = new RoleDto();
		RoleWidgets: ValueTextSelectedDto[] = [];
	}

	export class GetTaskPriorityStatusCommandResponse {
		PrioritySummary: ProjectPrioritySummaryDto = new ProjectPrioritySummaryDto();
	}

	export class GetUserCommandResponse {
		UserDto: UserDto = new UserDto();
	}

	export class GetUserWidgetSelectionsCommandResponse {
		Widgets: WidgetDto[] = [];
	}

	export class ImportPrimaveraP6CommandResponse {
	}

	export class ImportReadinessToolCommandResponse {
	}

	export class ImportSiteSenseCommandResponse {
		ProcessedProjects: SiteSenseProjectDto[] = [];
		BypassedProjects: SiteSenseProjectDto[] = [];
	}

	export class IsUserAuthenticatedCommandResponse {
		IsAuthenticated: boolean;
		UserInfo: UserInfoDto = new UserInfoDto();
	}

	export class LoginCommandResponse {
		UserInfo: UserInfoDto = new UserInfoDto();
	}

	export class PersistProjectSetupCommandResponse {
		ProjectInfo: ProjectSetupDto = new ProjectSetupDto();
	}

	export class SaveApplicationSettingCommandResponse {
		Id: number;
	}

	export class SaveCheckpointCommandResponse {
		Id: number;
	}

	export class SaveCountryCommandResponse {
		Id: number;
	}

	export class SaveExampleCommandResponse {
		Id: number;
	}

	export class SaveFormlyExampleCommandResponse {
		Id: number;
	}

	export class SaveRoleCommandResponse {
		Id: number;
	}

	export class SaveUserCommandResponse {
		Id: number;
	}

	export class SaveUserWidgetOrderCommandResponse {
	}

	export class SaveUserWidgetSelectionsCommandResponse {
	}

	export class SearchObjectsCommandResponse {
		Results: IPagedResult;
	}

	export class TestDummyCommandResponse {
		MyString: string;
		MyInt: number;
		MyNullableInt: number;
	}

	export class TriggerServerExceptionCommandResponse {
	}

	export class UnusedSecurityCheckpointSearchCommandResponse {
		PagedResult: IPagedResult;
		Columns: ColumnInformation[] = [];
	}

	export enum BatchProcessingQueueDefinition {
		TestDummy = 1,
		Email = 2,
	}

	export enum QueueEntryStatus {
		Pending = 0,
		Executing = 1,
		CompletedSuccessfully = 2,
		CompletedWithError = 3,
	}

	export enum WidgetType {
		Count = 0,
	}

	export let BatchProcessingQueueDefinitionDisplayOptions = [
		{ name: "TestDummy", value: "TestDummy", enum: BatchProcessingQueueDefinition.TestDummy },
		{ name: "Email", value: "Email", enum: BatchProcessingQueueDefinition.Email },
	];

	export let QueueEntryStatusDisplayOptions = [
		{ name: "Pending", value: "Pending", enum: QueueEntryStatus.Pending },
		{ name: "Executing", value: "Executing", enum: QueueEntryStatus.Executing },
		{ name: "CompletedSuccessfully", value: "CompletedSuccessfully", enum: QueueEntryStatus.CompletedSuccessfully },
		{ name: "CompletedWithError", value: "CompletedWithError", enum: QueueEntryStatus.CompletedWithError },
	];

	export let WidgetTypeDisplayOptions = [
		{ name: "Count", value: "Count", enum: WidgetType.Count },
	];

	export let BatchProcessingQueueDefinitionDisplayMap = {
		[BatchProcessingQueueDefinition.TestDummy]: "TestDummy",
		[BatchProcessingQueueDefinition.Email]: "Email",
	};

	export let QueueEntryStatusDisplayMap = {
		[QueueEntryStatus.Pending]: "Pending",
		[QueueEntryStatus.Executing]: "Executing",
		[QueueEntryStatus.CompletedSuccessfully]: "CompletedSuccessfully",
		[QueueEntryStatus.CompletedWithError]: "CompletedWithError",
	};

	export let WidgetTypeDisplayMap = {
		[WidgetType.Count]: "Count",
	};

	export class CommandNames {
		static Admin: String = "Admin"
		static CreateTestDummyCommandQueue: String = "CreateTestDummyCommandQueue"
		static CreateUser: String = "CreateUser"
		static DeleteCheckpoint: String = "DeleteCheckpoint"
		static DeleteExample: String = "DeleteExample"
		static DeleteRole: String = "DeleteRole"
		static ExecuteAllPendingQueues: String = "ExecuteAllPendingQueues"
		static ExecuteNextQueueEntry: String = "ExecuteNextQueueEntry"
		static ExecutePendingQueueEntries: String = "ExecutePendingQueueEntries"
		static GetApplicationSetting: String = "GetApplicationSetting"
		static GetCheckpoint: String = "GetCheckpoint"
		static GetClientAndAssetListByUser: String = "GetClientAndAssetListByUser"
		static GetCountry: String = "GetCountry"
		static GetDashboard: String = "GetDashboard"
		static GetExample: String = "GetExample"
		static GetException: String = "GetException"
		static GetExecutionBarChart: String = "GetExecutionBarChart"
		static GetExecutionChart: String = "GetExecutionChart"
		static GetExecutionCurrentStatusChart: String = "GetExecutionCurrentStatusChart"
		static GetExecutionStatus: String = "GetExecutionStatus"
		static GetMaterialsStatus: String = "GetMaterialsStatus"
		static GetPrimaveraSummaryReport: String = "GetPrimaveraSummaryReport"
		static GetProjectModuleDisplaySettings: String = "GetProjectModuleDisplaySettings"
		static GetProjectsByUser: String = "GetProjectsByUser"
		static GetProjectSetup: String = "GetProjectSetup"
		static GetQueueDetail: String = "GetQueueDetail"
		static GetReadinessStatus: String = "GetReadinessStatus"
		static GetReadinessSummary: String = "GetReadinessSummary"
		static GetReleaseNumber: String = "GetReleaseNumber"
		static GetRole: String = "GetRole"
		static GetTaskPriorityStatus: String = "GetTaskPriorityStatus"
		static GetUser: String = "GetUser"
		static GetUserWidgetSelections: String = "GetUserWidgetSelections"
		static ImportPrimaveraP6: String = "ImportPrimaveraP6"
		static ImportReadinessTool: String = "ImportReadinessTool"
		static ImportSiteSense: String = "ImportSiteSense"
		static IsUserAuthenticated: String = "IsUserAuthenticated"
		static Login: String = "Login"
		static Logout: String = "Logout"
		static LogTypeScriptError: String = "LogTypeScriptError"
		static PersistProjectSetup: String = "PersistProjectSetup"
		static SaveApplicationSetting: String = "SaveApplicationSetting"
		static SaveCheckpoint: String = "SaveCheckpoint"
		static SaveCountry: String = "SaveCountry"
		static SaveExample: String = "SaveExample"
		static SaveFormlyExample: String = "SaveFormlyExample"
		static SaveRole: String = "SaveRole"
		static SaveUser: String = "SaveUser"
		static SaveUserWidgetOrder: String = "SaveUserWidgetOrder"
		static SaveUserWidgetSelections: String = "SaveUserWidgetSelections"
		static SearchObjects: String = "SearchObjects"
		static TestDummy: String = "TestDummy"
		static TriggerServerException: String = "TriggerServerException"
		static UnusedSecurityCheckpointSearch: String = "UnusedSecurityCheckpointSearch"
	}




// WEBPACK FOOTER //
// ./src/app/data/CommandServiceDtos.generated.ts